import { useQuery } from '@tanstack/react-query';
import { api } from '../api.js';

export const DAY_ENTRIES_KEY = (date: string) => ['entries', date] as const;

export function useDayEntries(date: string, enabled = true) {
  return useQuery({
    queryKey: DAY_ENTRIES_KEY(date),
    queryFn: async () => {
      const { data, response } = await api.GET('/me/days/{date}/entries', {
        params: { path: { date } },
      });
      if (!data) throw new Error(`GET /me/days/${date}/entries: ${response.status}`);
      return data;
    },
    enabled,
    staleTime: 30_000,
    retry: false,
  });
}
